import { DefaultRootState } from 'react-redux';
import { userSelector } from '../auth/selectors/auth.selectors';
import { ecgIdSelector } from '../ecg/selectors/ecg.selectors';
import { getApplicationPath } from '../ecg/utils/application-path.utils';
import {
  AnalyticsEvent,
  BaseAnalyticsPage,
  IdentifyEvent,
} from './types/analytics.types';

export const track = ({ name, properties }: AnalyticsEvent) => {
  window.analytics.track(name, properties);
};

export const sendPage = ({ page, properties }: BaseAnalyticsPage) => {
  window.analytics.page(page, properties);
};

export const identify = (userId: string, traits: IdentifyEvent) => {
  window.analytics.identify(userId, traits);
};

export const getEnvironment = () => {
  const hostArr = window.location.host.split('.');
  const environmentIndex = hostArr.indexOf('cardiologs');
  const environment = hostArr[environmentIndex - 1];
  if (environment == null) {
    // a new local proxy or localhost
    return 'staging';
  }
  return environment;
};

export const getBaseProperties = (getState: () => DefaultRootState) => {
  const view = getApplicationPath(window.location);
  const ecgId = ecgIdSelector(getState());
  const user = userSelector(getState());

  if (view == null || ecgId == null || user == null) {
    return null;
  }

  return { view, ecgId, userId: user.id };
};
